import { PropsWithChildren, useReducer } from 'react'
import { reducer } from '../reducers/DragNDrop.reducer'
import { initialDndState } from '../utils/dnd.utils'
import { DragNDropContext } from '../contexts/DragNDrop.context'

export const DragNDropContextProvider = ({ children }: PropsWithChildren) => {
  const [state, dispatch] = useReducer(reducer, initialDndState)

  return (
    <DragNDropContext.Provider value={{ state, dispatch }}>
      {children}
    </DragNDropContext.Provider>
  )
}
